export const plansData = [
    {
        name: "Basic",
        price: "Gratuit",
        features: [
          "Accès aux offres d'emploi basiques",
          "Création d'un CV simple",
          "Inscription aux formations gratuites",
          "Alertes personnalisées pour les nouvelles offres correspondant à votre profil"
        ],
        description: "Pour les candidats en début de carrière ou les formateurs qui débutent.",
        buttonLabel: "Commencer gratuitement"
      },
      {
        name: "Standard",
        price: "40.000 Ariary",
        features: [
          "Accès complet aux offres d'emploi",
          "Création de CV avancé avec des modèles personnalisés",
          "Participation à des formations en ligne certifiantes",
          "Suivi des candidatures en temps réel",
          "Accès aux conseils et guides de gestion de carrière"
        ],
        description: "Pour les professionnels en pleine évolution ou les formateurs expérimentés.",
        buttonLabel: "S'abonner"
      },
      {
        name: "Professional",
        price: "50.000 Ariary",
        features: [
          "Tout le contenu du plan Standard",
          "Coaching personnalisé de carrière",
          "Accès à des offres d'emploi exclusives",
          "Accès à des ateliers de formation premium",
          "Support prioritaire"
        ],
        description: "Pour les professionnels confirmés et formateurs chevronnés.",
        buttonLabel: "Passer au Professional"
      },
]